import { Post, PostStatus } from '@tribeplatform/gql-client/types'
import { useRouter } from '@tribeplatform/react-sdk'

import { DotSeparator } from '../common/components/DotSeparator.js'
import { Time } from '../common/components/Time.js'
import { dayjs } from '../common/lib/dayjs.js'
import { T } from '../i18n/components/T.js'

import { DraftPostHeader } from './DraftPostHeader.js'

interface Props {
  post: Partial<Post>
  showSpace?: boolean
  memberName?: string
  memberTagline?: string
}

export const PostMemberBarInfo = ({
  post,
  showSpace = true,
  memberName,
  memberTagline,
}: Props) => {
  const { Link } = useRouter()
  const postDate = post?.publishedAt || post?.createdAt

  if (post.status === PostStatus.DRAFT) {
    return (
      <DraftPostHeader
        updatedAt={post.updatedAt}
        scheduledFor={post.scheduledFor}
      />
    )
  }

  if (showSpace && post.space?.slug) {
    return (
      <div className="flex items-center gap-1 truncate">
        <Link
          variant="inherit"
          href={post.relativeUrl}
          className="shrink-0"
          truncate
        >
          <Time dateTime={postDate}>{dayjs(postDate).fromNow()}</Time>
        </Link>
        <DotSeparator />
        <Link
          variant="inherit"
          href={post.space.relativeUrl}
          truncate
          title={post.space.name}
          aria-label={post.space.name}
        >
          <T
            defaultMessage="Posted in {space}"
            id="PostMemberBar.PostSpace"
            values={{
              space: post.space.name,
            }}
          />
        </Link>
      </div>
    )
  }

  return (
    <div className="flex items-center gap-1 truncate">
      <Link variant="inherit" href={post.relativeUrl} truncate>
        <Time dateTime={postDate}>
          {memberName ? (
            <>{dayjs(postDate).fromNow()}</>
          ) : (
            <div className="h-3 w-16 bg-surface-pressed rounded-full"></div>
          )}
        </Time>
      </Link>
      {memberTagline ? (
        <>
          <DotSeparator />
          <span className="truncate">{memberTagline}</span>
        </>
      ) : null}
    </div>
  )
}
